export enum HealthcareCoveragesEnum {
    BASIC = 1019,
    STANDARD = 1018,
    PLUS = 1020
}
